/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { UiPolicyConfig } from '../models/ui-policy-config';

@Injectable({
  providedIn: 'root',
})
export class UiPolicyService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getUiPolicy
   */
  static readonly GetUiPolicyPath = '/config/policy/{id}';

  /**
   * Get UI policy configuration for a tenant.
   *
   * Returns the UI policy document that governs component visibility and behavior for the CareFindr V3 frontend. The id path parameter is a hash token that maps to an internal page name.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUiPolicy()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUiPolicy$Response(params: {

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Page hash token that resolves to an internal page name.
     */
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UiPolicyConfig>> {

    const rb = new RequestBuilder(this.rootUrl, UiPolicyService.GetUiPolicyPath, 'get');
    if (params) {
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.header('x-persona', params['x-persona'], {});
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UiPolicyConfig>;
      })
    );
  }

  /**
   * Get UI policy configuration for a tenant.
   *
   * Returns the UI policy document that governs component visibility and behavior for the CareFindr V3 frontend. The id path parameter is a hash token that maps to an internal page name.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUiPolicy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUiPolicy(params: {

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Page hash token that resolves to an internal page name.
     */
    id: string;
  },
  context?: HttpContext

): Observable<UiPolicyConfig> {

    return this.getUiPolicy$Response(params,context).pipe(
      map((r: StrictHttpResponse<UiPolicyConfig>) => r.body as UiPolicyConfig)
    );
  }

}
